import { useNavigate } from "react-router-dom";
import { GatewayInfoSocieteOrias } from "@conformite/gateway";
import { ConformiteSocieteList } from "./ConformiteSocieteList";

export function ConformiteSocieteListGarantieFinanciereIobsp() {
  const navigate = useNavigate();

  return (
    <ConformiteSocieteList
      getFormAvancement={(entreprise) =>
        entreprise.avancement.garantieFinanciereIobsp ?? 0
      }
      defaultFilters={{
        categories: GatewayInfoSocieteOrias.CategorieIOBSPList,
      }}
      title="Garantie financière IOBSP"
      onSocieteRedirect={(entreprise) => {
        navigate(`${entreprise.siren}?fromAxe`);
      }}
    />
  );
}
